<div class="qr-wrapper">
    <div class="wrapper--center camera-not-found" *ngIf="cameraNotFound">
        <div class="qr-reader-container qr-reader-container--no-camera">
            <p class="title title--size-l text--center">
                {{ "WALLET.SEND.SCAN-QR.CAMERA-NOT-FOUND" | translate }}
            </p>
        </div>
    </div>
    <div class="wrapper--center" *ngIf="!cameraNotFound">
        <div class="qr-reader-container">
            <div class="qr-reader">
                <video
                    #qrReaderEl
                    class="qr-reader-el"
                    playsinline="true"
                    autoplay="true"
                    muted="true"
                ></video>
            </div>
        </div>
    </div>
    <div class="wrapper--center button-close">
        <button class="btn" style="margin-top: 16px" (click)="closeQr()">
            Close
        </button>
    </div>
</div>
